import React from 'react';
import { Routes, Route } from 'react-router-dom'; // Tady jsem smazal 'BrowserRouter as Router'
import './index.css';
import Home from './home/index'; 
import Gallery from './gallery/index'; 
import Contact from './contact/index'; 

function App() {
  return (
    /* Smazal jsem ten <Router> tag, nechal jsem jen ty cesty (Routes) */
    <Routes>
      {/* Hlavní strana */}
      <Route path="/" element={<Home />} />
      
      {/* Galerie */}
      <Route path="/gallery" element={<Gallery />} />
      
      {/* Kontakt */}
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
}

export default App;